// import React, { useEffect } from "react";
// import "../../EcoPalmProducts/EcoPalmProducts.css";
// import Card from "../../../../../components/Card";
// import Breadcrumb from "../../../../../components/Breadcrum";

// // Centralized image import for better management
// const images = {
//   banner: "./assets/img/contact-banner.png",
//   ECO: "./assets/img/agriculturalCommodities/spices.jpg",

//   Turmeric: "/assets/img/Spices/Turmeric.jpg",
//   BlackPepper: "/assets/img/Spices/Black-pepper.jpg",
//   Cumin: "/assets/img/Spices/Cumin.jpg",
//   Cardamom: "/assets/img/Spices/Cardamom.jpg",
//   Nutmeg: "/assets/img/Spices/Nutmeg.jpg",
//   NutMace: "/assets/img/Spices/Nut-Mace.jpg",
//   StarAnise: "/assets/img/Spices/Star-Anise.jpg",
//   Cinnamon: "/assets/img/Spices/Cinnamon.jpg",
//   DryGinger: "/assets/img/Spices/Dry-Ginger.jpg",
//   BirdsEyeChilies: "/assets/img/Spices/Birds-Eye-Chilies.jpg",
//   RedChilies: "/assets/img/Spices/Red-Chilli.jpg",
//   // Spices: "/assets/img/Spices/Cardamom.jpg",
//   ChilliFlakes: "/assets/img/Spices/Chilli-Flakes.jpg",
//   BlackSalt: "/assets/img/Spices/Black-Salt.jpg",
//   CarromSeedAjwain: "/assets/img/Spices/Carrom-Seed-Ajwain.jpg",
//   ChiaSeeds: "/assets/img/Spices/Chia-Seeds.jpg",
//   Chickpea: "/assets/img/Spices/Chickpea.jpg",
//   Clove: "/assets/img/Spices/Clove.jpg",
//   CorianderSeeds: "/assets/img/Spices/Coriander-Seeds.jpg",
//   CuminSeed: "/assets/img/Spices/Cumin-Seed.jpg",
//   DriedMint: "/assets/img/Spices/Dried-Mint.jpg",
//   FennelSeed: "/assets/img/Spices/Fennel-Seed.jpg",
//   FenugreekSeed: "/assets/img/Spices/Fenugreek-Seed.jpg",
//   // Ginger: "/assets/img/Spices/Ginger.jpg",
//   HimalayanPinkSalt: "/assets/img/Spices/Himalayan-Pink-Salt.jpg",
//   JaggeryPowder: "/assets/img/Spices/Jaggery-Powder.jpg",
//   MustardSeed: "/assets/img/Spices/Mustard-Seed.jpg",
//   NigellaSeedKalongi: "/assets/img/Spices/Nigella-Seed-Kalongi.jpg",
//   RockSalt: "/assets/img/Spices/Rock-Salt.jpg",
//   SesameSeed: "/assets/img/Spices/Sesame-Seed.jpg",
//   TableSalt: "/assets/img/Spices/Table-Salt.jpg",
//   AmarnathSeed: "/assets/img/Spices/Amarnath-Seed.jpg",

// };

// // for reference 
// // const cardData = [
// //   {
// //     id: "wholeChilli",
// //     image: images.whole_chilli,                       Spices (Processed):
// //     title: "Red Chilli Whole",
// //     description:
// //       "Crafted for main courses, these plates provide a sturdy and stylish base for your meals.",
// // }];

// const cardData = [
//   { id: "Turmeric", image: images.Turmeric },
//   { id: "Black Pepper", image: images.BlackPepper },
//   { id: "Cumin", image: images.Cumin },
//   { id: "Cardamom", image: images.Cardamom },
//   { id: "Nutmeg", image: images.Nutmeg },
//   { id: "Nut Mace", image: images.NutMace },
//   { id: "Star Anise", image: images.StarAnise },
//   { id: "Cinnamon", image: images.Cinnamon },
//   { id: "Dry Ginger", image: images.DryGinger },
//   { id: "Bird’s Eye Chilies", image: images.BirdsEyeChilies },
//   { id: "Red Chilies", image: images.RedChilies },
//   // { id: "Spices", image: images.Spices },
//   { id: "ChilliFlakes", image: images.ChilliFlakes },
//   // { id: "BlackSalt", image: images.BlackSalt },
//   // { id: "CarromSeedAjwain", image: images.CarromSeedAjwain },
//   // { id: "ChiaSeeds", image: images.ChiaSeeds },
//   // { id: "Chickpea", image: images.Chickpea },
//   // { id: "Clove", image: images.Clove },
//   // { id: "CorianderSeeds", image: images.CorianderSeeds },
//   // { id: "CuminSeed", image: images.CuminSeed },
//   // { id: "DriedMint", image: images.DriedMint },
//   // { id: "FennelSeed", image: images.FennelSeed },
//   // { id: "FenugreekSeed", image: images.FenugreekSeed },
//   // // { id: "Ginger", image: images.Ginger },
//   // { id: "HimalayanPinkSalt", image: images.HimalayanPinkSalt },
//   // { id: "JaggeryPowder", image: images.JaggeryPowder },
//   // { id: "MustardSeed", image: images.MustardSeed },
//   // { id: "NigellaSeedKalongi", image: images.NigellaSeedKalongi },
//   // { id: "RockSalt", image: images.RockSalt },
//   // { id: "SesameSeed", image: images.SesameSeed },
//   // { id: "TableSalt", image: images.TableSalt },
//   // { id: "AmarnathSeed", image: images.AmarnathSeed },

// ];


// export default function Spices() {
//   // Ensuring smooth scroll restoration
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   return (
//     <>
//       <Breadcrumb
//         title="Spices"
//         backgroundImage={images.banner}
//         height="40vh"
//       ></Breadcrumb>
//       <section className="main-services cardContainer pt-5">
//         {/* <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="service-item">
//                 <div className="row">
//                   <div className="col-lg-4">
//                     <div className="left-image">
//                       <img src={images.ECO} alt="Digital Currencies" />
//                     </div>
//                   </div>
//                   <div className="col-lg-8 align-self-center">
//                     <div className="right-text-content">
//                       <p className="justify">
//                         At Dohrnii Exim Private Limited, we are proud to be one of the leading exporters of premium Indian spices. Our extensive range includes both whole and ground spices such as Chili, Turmeric, Cumin, Coriander, Fennel, Fenugreek, and many more. Sourced from the best farms across India, our spices are known for their rich flavor, color, and authenticity. We ensure the highest quality standards, offering our clients worldwide the finest spices for culinary excellence. Whether for wholesale or retail, we are committed to delivering products that enhance the taste and aroma of every dish
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div> */}
//       </section>
//       <div className="cardContainer mb-5">
//         <div className="container">
//           <div className="row g-lg-5 g-4">
//             {cardData.map((card) => (
//               <div key={card.id} className="col-lg-4 col-md-6 col-12">
//                 <Card
//                   image={card.image}
//                   title={card.title}
//                   id={card.id}
//                   description={card.description}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }



import React, { useEffect, useState } from "react";
import "../../EcoPalmProducts/EcoPalmProducts.css";
import Card from "../../../../../components/Card";
import Breadcrumb from "../../../../../components/Breadcrum";
import { Modal } from "bootstrap";

/* ================= IMAGES ================= */
const images = {
  banner: "./assets/img/contact-banner.png",

  Turmeric: "/assets/img/Spices/Turmeric.jpg",
  BlackPepper: "/assets/img/Spices/Black-pepper.jpg",
  Cumin: "/assets/img/Spices/Cumin.jpg",
  Cardamom: "/assets/img/Spices/Cardamom.jpg",
  Nutmeg: "/assets/img/Spices/Nutmeg.jpg",
  NutMace: "/assets/img/Spices/Nut-Mace.jpg",
  StarAnise: "/assets/img/Spices/Star-Anise.jpg",
  Cinnamon: "/assets/img/Spices/Cinnamon.jpg",
  DryGinger: "/assets/img/Spices/Dry-Ginger.jpg",
  BirdsEyeChilies: "/assets/img/Spices/Birds-Eye-Chilies.jpg",
  RedChilies: "/assets/img/Spices/Red-Chilli.jpg",
  ChilliFlakes: "/assets/img/Spices/Chilli-Flakes.jpg",
  CorianderSeeds: "/assets/img/Spices/Coriander-Seeds.jpg",
  FennelSeed: "/assets/img/Spices/Fennel-Seed.jpg",
  FenugreekSeed: "/assets/img/Spices/Fenugreek-Seed.jpg",
  NigellaSeedKalongi: "/assets/img/Spices/Nigella-Seed-Kalongi.jpg",
  MustardSeed: "/assets/img/Spices/Mustard-Seed.jpg",
  Clove: "/assets/img/Spices/Clove.jpg",
  Ginger: "/assets/img/Spices/Ginger.jpg",
  Cinnamon: "/assets/img/Spices/Cinnamon.jpg",
  Chickpea: "/assets/img/Spices/Chickpea.jpg",
  SesameSeed: "/assets/img/Spices/Sesame-Seed.jpg",
  DriedMint: "/assets/img/Spices/Dried-Mint.jpg",
  TableSalt: "/assets/img/Spices/Table-Salt.jpg",
  RockSalt: "/assets/img/Spices/Rock-Salt.jpg",
  BlackSalt: "/assets/img/Spices/Black-Salt.jpg",
  HimalayanPinkSalt: "/assets/img/Spices/Himalayan-Pink-Salt.jpg",
};

/* ================= CARD DATA (12) ================= */
const cardData = [
  {
    id: "Cumin",
    image: images.Cumin,
    description:
      "Aromatic spice known for its warm flavor and widely used in culinary, seasoning, and food processing applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Turmeric",
    image: images.Turmeric,
    description:
      "A vibrant yellow spice known for its earthy flavor and widely used in cooking, seasoning, and food processing industries.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Cardamom",
    image: images.Cardamom,
    description:
      "Premium spice prized for its sweet aroma and distinctive flavor, commonly used in food, beverages, and confectionery.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Nutmeg",
    image: images.Nutmeg,
    description:
      "Highly valued spice with a warm, sweet flavor used in bakery products, beverages, and savory dishes.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "NutMace",
    image: images.NutMace,
    description:
      "A fragrant spice derived from nutmeg, known for its delicate flavor and extensive culinary applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "StarAnise",
    image: images.StarAnise,
    description:
      "Distinctive star-shaped spice with a sweet licorice flavor, widely used in seasoning blends and beverages.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Cinnamon",
    image: images.Cinnamon,
    description:
      "Premium-quality spice known for its sweet aroma and warm flavor, widely used in food and beverage industries.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "DryGinger",
    image: images.DryGinger,
    description:
      "Naturally dried ginger offering a strong aroma and flavor, commonly used in food processing and herbal preparations.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "BirdsEyeChilies",
    image: images.BirdsEyeChilies,
    description:
      "Hot and flavorful chilies known for their intense pungency and use in sauces, seasonings, and spicy dishes.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "RedChilies",
    image: images.RedChilies,
    description:
      "High-quality red chilies valued for their vibrant color, pungency, and wide culinary applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "ChilliFlakes",
    image: images.ChilliFlakes,
    description:
      "Crushed dried chilies used to add heat, flavor, and texture to a variety of food preparations.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "CorianderSeeds",
    image: images.CorianderSeeds,
    description:
      "Aromatic seeds widely used in spice blends, seasonings, and traditional culinary preparations.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "FennelSeed",
    image: images.FennelSeed,
    description:
      "Sweet and aromatic seeds commonly used in cooking, confectionery, beverages, and mouth fresheners.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "FenugreekSeed",
    image: images.FenugreekSeed,
    description:
      "Nutritious spice seeds known for their distinctive flavor and use in food processing and traditional recipes.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "NigellaSeedKalongi",
    image: images.NigellaSeedKalongi,
    description:
      "Premium black seeds with a unique flavor profile, commonly used in baking, seasoning, and spice blends.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "MustardSeed",
    image: images.MustardSeed,
    description:
      "Widely used spice seed known for its pungent flavor and application in pickles, seasonings, and sauces.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Clove",
    image: images.Clove,
    description:
      "Highly aromatic spice valued for its intense flavor and extensive use in food, beverages, and spice blends.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Ginger",
    image: images.Ginger,
    description:
      "Fresh and flavorful spice widely used in culinary preparations, beverages, and traditional wellness products.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "Chickpea",
    image: images.Chickpea,
    description:
      "Premium-quality chickpeas rich in nutrition and widely used in food processing and culinary applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "SesameSeed",
    image: images.SesameSeed,
    description:
      "Nutritious oil-rich seeds widely used in bakery products, confectionery, cooking, and food manufacturing.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "DriedMint",
    image: images.DriedMint,
    description:
      "Naturally dried mint leaves offering refreshing flavor and aroma for culinary and beverage applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "TableSalt",
    image: images.TableSalt,
    description:
      "Refined food-grade salt widely used for seasoning, food preservation, and industrial food applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "RockSalt",
    image: images.RockSalt,
    description:
      "Natural mineral-rich salt valued for its purity and use in culinary and food processing industries.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "BlackSalt",
    image: images.BlackSalt,
    description:
      "Traditional mineral salt known for its distinctive flavor and use in culinary and seasoning applications.",
    origin: "India",
    season: "January to December",
  },
  {
    id: "HimalayanPinkSalt",
    image: images.HimalayanPinkSalt,
    description:
      "Premium pink salt renowned for its natural minerals, purity, and culinary versatility.",
    origin: "India",
    season: "January to December",
  },

];

/* ================= COMPONENT ================= */
export default function Spices() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openModal = (product) => {
    setSelectedProduct(product);
    setTimeout(() => {
      const modal = new Modal(document.getElementById("productModal"));
      modal.show();
    }, 100);
  };

  return (
    <>
      <Breadcrumb
        title="Spices"
        backgroundImage={images.banner}
        height="40vh"
      />

      <div className="cardContainer mb-5 pt-5">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
                <div
                  onClick={() => openModal(card)}
                  style={{ cursor: "pointer" }}
                >
                  <Card image={card.image} title={card.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ========== MODAL ========== */}
      <div
        className="modal fade"
        id="productModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{selectedProduct?.title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div className="text-center mb-4">
                <img
                  src={selectedProduct?.image}
                  alt={selectedProduct?.title}
                  className="img-fluid rounded"
                  style={{ maxHeight: "300px" }}
                />
              </div>

              <p><strong>Description:</strong> {selectedProduct?.description}</p>
              <p><strong>Origin:</strong> {selectedProduct?.origin}</p>
              <p><strong>Season:</strong> {selectedProduct?.season}</p>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 